import { connect } from 'react-redux';
import * as core from 'cw-ui-core';
import App from './App';

const mapStateToProps = (state) => {
  return {
    partnerPortalUrl: core.getModuleConfig(state.module, ['partnerPortalUrl']),
    stsUserAdminUrl: core.getModuleConfig(state.module, ['stsUserAdminUrl']),
    showMenu: core.getScreenCustom(state.screen, ['showMenu']),
    showControl: core.getModuleConfig(state.module, ['build']) !== 'prod'
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onShowMenuChanged: (showMenu) => {
      dispatch(core.setScreenCustom(['showMenu'], showMenu));
    }
  };
};

const AppContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default AppContainer;


// WEBPACK FOOTER //
// ./src/components/App/AppContainer.js